import React from "react";
import { Link, Switch, Route, Redirect } from "react-router-dom";
import Logo from "./logo.png";
import "../../../_psb/_assets/sass/pages/login/login-1.scss";
import Login from "./Login";
import Admin from "./adminRegistration";
import Artisan from "./artisanRegistration";
import Customer from "./customerRegistration";
import Supplier from "./supplierRegistration";
import ForgotPassword from "./ForgotPassword";
import resetPassword from "./ResetPassword";
import LoginNewPage from "./LoginNewPage";
import { FormattedMessage, injectIntl } from "react-intl";
import { Grid } from "@material-ui/core";
import { Col, Row } from "reactstrap";
import NewForgotPassword from "./NewForgotPassword";
import NewResetPassword from "./NewResetPassword";
import LoginToken from "./LoginToken";

function AuthPage() {
  return (
    // <Row style={{ height: '100vh' }}>
    //   <Col md='4' style={{ backgroundColor: '#333' }}>
    //     <Row
    //       className='justify-content-center align-items-center '
    //       style={{ height: '100vh' }}
    //     >
    //       <div
    //         className='d-flex flex-column align-items-center  justify-content-between'
    //         style={{ height: '80%' }}
    //       >
    //         <div className='d-flex flex-column align-items-center'>
    //           <div className='kt-grid__item mb-3 '>
    //             <Link to='/' className='kt-login__logo'>
    //               <img alt='Logo' src={Logo} style={{ width: '250px' }} />
    //             </Link>
    //           </div>
    //           <div className='kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver'>
    //             <div className='kt-grid__item kt-grid__item--middle'>
    //               <h3 className='kt-login__title text-white'>
    //                 {/* Welcome to Warshatna!{' '} */}
    //                 <FormattedMessage id='AUTH.WELCOME.TITLE' />
    //               </h3>
    //               {/*      <h4 className="kt-login__subtitle">
    //                 The ultimate Bootstrap & Angular 6 admin theme framework for
    //                 next generation web apps.
    //               </h4> */}
    //             </div>
    //           </div>

    //           {/* <span className='text-white mt-5'>Create an account</span>
    //           &nbsp;&nbsp;
    //           <div>
    //             <Link to='/artisan-registration' className='text-white border-bottom'>
    //               <FormattedMessage id='AUTH.REGISTER_ARTISAN.LINK' />
    //             </Link>
    //             &nbsp;&nbsp;
    //             <Link to='/customer-registration' className='text-white border-bottom'>
    //               <FormattedMessage
    //                 id='AUTH.REGISTER_CUSTOMER.LINK'

    //               />
    //             </Link>
    //             &nbsp;&nbsp;
    //             <Link to='/admin-registration' className='text-white border-bottom'>
    //               <FormattedMessage
    //                 id='AUTH.REGISTER_ADMIN.LINK'
    //               />
    //             </Link>
    //             &nbsp;&nbsp;
    //             <Link to='/supplier-registration' className='text-white border-bottom'>
    //               <FormattedMessage
    //                 id='AUTH.REGISTER_SUPPLIER.LINK'
    //               />
    //             </Link>
    //           </div> */}
    //         </div>
    //         <div className='kt-grid__item p-0'>
    //           <div className='kt-login__info d-flex flex-column align-items-center'>
    //             <div className='kt-login__copyright text-white mb-4'>
    //               &copy; 2020 - 2021 Warshatna
    //             </div>
    //             <div className='kt-login__menu '>
    //               <Link to='/terms' className='kt-link text-white'>
    //                 {/* Privacy */}
    //                 <FormattedMessage id='AUTH.PAGE.PRIVACY' />
    //               </Link>
    //               <Link to='/terms' className='kt-link text-white px-5'>
    //                 {/* Legal */}
    //                 <FormattedMessage id='AUTH.PAGE.LEGAL' />
    //               </Link>
    //               <Link to='/terms' className='kt-link text-white'>
    //                 {/* Contact */}
    //                 <FormattedMessage id='AUTH.PAGE.CONTACT' />
    //               </Link>
    //             </div>
    //           </div>
    //         </div>
    //       </div>
    //     </Row>
    //   </Col>
    //   <Col
    //     md='8'
    //     id='kt_login'
    //     className='p-0 kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1'
    //   >
    //     <div className='kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper'>
    <Switch>
      <Route path="/auth/user/:token" component={LoginToken} />
      <Route path="/auth/login" component={LoginNewPage} />
      <Route path="/admin-registration" component={Admin} />
      <Route path="/artisan-registration" component={Artisan} />
      <Route path="/customer-registration" component={Customer} />
      <Route path="/supplier-registration" component={Supplier} />
      <Route path="/auth/forgot-password" component={NewForgotPassword} />
      <Route
        path="/forget-password/confirm/:token"
        component={NewResetPassword}
      />
      <Redirect
        to={{ pathname: "/auth/login", state: { from: "/auth" } }}
        exact
      />
      <Redirect to={{ pathname: "/auth/login" }} />
    </Switch>
    //        </div>
    //    </Col>
    // </Row>
    // <Grid>
    //   <div className="kt-grid kt-grid--ver kt-grid--root">
    //     <div
    //       id="kt_login"
    //       className="kt-grid kt-grid--hor kt-grid--root kt-login kt-login--v1"
    //     >
    //       <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--desktop kt-grid--ver-desktop kt-grid--hor-tablet-and-mobile">
    //         <div
    //           className="kt-grid__item kt-grid__item--order-tablet-and-mobile-2 kt-grid kt-grid--hor kt-login__aside"
    //           style={{
    //             backgroundColor: '#333',
    //             /*                 backgroundImage: `url(${toAbsoluteUrl("/media/bg/bg-4.jpg")})`
    //              */
    //           }}
    //         >
    //           <div className="kt-grid__item">
    //             <Link to="/" className="kt-login__logo">
    //               <img alt="Logo" src={Logo} />
    //             </Link>
    //           </div>
    //           <div className="kt-grid__item kt-grid__item--fluid kt-grid kt-grid--ver">
    //             <div className="kt-grid__item kt-grid__item--middle">
    //               <h3 className="kt-login__title">
    //                 {/* Welcome to Warshatna!{' '} */}
    //                 <FormattedMessage id="AUTH.WELCOME.TITLE" />
    //               </h3>
    //               {/*      <h4 className="kt-login__subtitle">
    //                 The ultimate Bootstrap & Angular 6 admin theme framework for
    //                 next generation web apps.
    //               </h4> */}
    //             </div>
    //           </div>
    //           <div className="kt-grid__item">
    //             <div className="kt-login__info">
    //               <div className="kt-login__copyright">
    //                 &copy; 2018 Warshatna
    //               </div>
    //               <div className="kt-login__menu">
    //                 <Link to="/terms" className="kt-link">
    //                   {/* Privacy */}
    //                     <FormattedMessage id="AUTH.PAGE.PRIVACY" />
    //                 </Link>
    //                 <Link to="/terms" className="kt-link">
    //                   {/* Legal */}
    //                     <FormattedMessage id="AUTH.PAGE.LEGAL" />
    //                 </Link>
    //                 <Link to="/terms" className="kt-link">
    //                   {/* Contact */}
    //                     <FormattedMessage id="AUTH.PAGE.CONTACT" />
    //                 </Link>
    //               </div>
    //             </div>
    //           </div>
    //         </div>

    //         <div className="kt-grid__item kt-grid__item--fluid  kt-grid__item--order-tablet-and-mobile-1  kt-login__wrapper">
    //           <Switch>
    //             <Route path="/auth/login" component={Login} />
    //             <Route path="/admin-registration" component={Admin} />
    //             <Route path="/artisan-registration" component={Artisan} />
    //             <Route path="/customer-registration" component={Customer} />
    //             <Route path="/supplier-registration" component={Supplier} />
    //             <Route
    //               path="/auth/forgot-password"
    //               component={ForgotPassword}
    //             />
    //             <Route
    //               path="/forget-password/confirm/:token"
    //               component={resetPassword}
    //             />
    //             <Redirect
    //               to={{ pathname: '/auth/login', state: { from: '/auth' } }}
    //               exact
    //             />
    //             <Redirect to={{ pathname: '/auth/login' }} />
    //           </Switch>
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </Grid>
  );
}

export default injectIntl(AuthPage);
